import {
  MEDIA_CENTER_QUERY_KEYS,
  MEDIA_CENTER_RAILS_TYPE,
} from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { usePrefetchFileComments } from 'hb-react/shared/components/DesignSystem/Reactions/hooks/usePrefetchFileComments';
import { usePrefetchFileLikes } from 'hb-react/shared/components/DesignSystem/Reactions/hooks/usePrefetchFileLikes';

export const usePrefetchLikesAndComments = ({
  fileId,
  showReactions = true,
}) => {
  const { currentUser } = useDefaultAppContexts();

  usePrefetchFileLikes({
    fileId,
    userId: currentUser.id,
    queryKey: MEDIA_CENTER_QUERY_KEYS.likes,
    railsType: MEDIA_CENTER_RAILS_TYPE,
    showReactions,
  });

  usePrefetchFileComments({
    fileId,
    userId: currentUser.id,
    queryKey: MEDIA_CENTER_QUERY_KEYS.comments,
    railsType: MEDIA_CENTER_RAILS_TYPE,
    showReactions,
  });
};
